export default __webpack_public_path__ + "14a7b68b48ac0bdfb81ba2a608d8dad1.jpg";